import { makeUnknownFromEmpty } from "Investigate/utils";

export const PAGE_SIZE = 10;
const SPEND_COL_MIN_WIDTH = 140;

export const getColumnDefs = (
	dimensionHeaders,
	spendFormatter,
	sortModel,
	totalCount
) => {
	return [
		{
			headerName: `Vendors (${totalCount})`,
			field: 'vendorName',
			colId: 'vendorName',
			minWidth: 190,
			sortable: true,
			...(sortModel && sortModel.colId === 'vendorName'
				? { sort: sortModel.sort }
				: {}),
		},
		{
			headerName: 'Total spend',
			field: 'spend',
			colId: 'spend',
			type: 'numericColumn',
			headerClass: 'ag-numeric-header',
			cellStyle: { textAlign: 'right' },
			minWidth: SPEND_COL_MIN_WIDTH,
			sortable: true,
			...(sortModel && sortModel.colId === 'spend'
				? { sort: sortModel.sort }
				: {}),
			valueFormatter: params => spendFormatter(params.value),
		},
		{
			headerName: 'Top L4 category',
			field: 'l4Category',
			minWidth: 140,
			width: 140,
			cellClass: 'categories-column',
		},
		{
			headerName: '',
			field: 'l4Category',
			minWidth: 40,
			width: 40,
			maxWidth: 40,
			lockVisible: true,
			cellRenderer: 'categoriesCellRenderer',
		},
		...(dimensionHeaders
			? dimensionHeaders.map(({ colName }, index) => ({
					headerName: makeUnknownFromEmpty(colName),
					headerClass: `ag-numeric-header dimension-header color-${index + 1}`,
					colId: colName,
					type: 'numericColumn',
					cellStyle: { direction: 'rtl' },
					minWidth: SPEND_COL_MIN_WIDTH,
					sortable: colName !== 'Others',
					...(sortModel && sortModel.colId === colName
						? { sort: sortModel.sort }
						: {}),
					valueGetter: params => {
						return (
							params &&
							params.data &&
							params.data.spendSplit &&
							params.data.spendSplit[index]
						);
					},
					valueFormatter: params => {
						return params.value
							? `${spendFormatter(params.value)} (${Math.round(
									(params.value / params.data.spend) * 100
							  )}%)`
							: '-';
					},
			  }))
			: []),
	];
};
